import { Check } from "lucide-react";

export const OptionRow = ({ type, checked, onClick, label, price, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-left transition-colors ${checked ? "border-amber-500 bg-amber-500/10" : "border-[#2E2323] bg-[#120E0E] hover:border-[#4a3838]"}`}>
    <span className={`w-5 h-5 shrink-0 flex items-center justify-center border-2 ${type === "radio" ? "rounded-full" : "rounded-md"} ${checked ? "border-amber-500 bg-amber-500" : "border-[#4a3838]"}`}>
      {checked && <Check className="w-3 h-3 text-[#120E0E]" strokeWidth={4} />}
    </span>
    <span className="flex-1 text-sm">{label}</span>
    <span className="text-xs text-amber-300 font-semibold">{price}</span>
  </button>
);
